export default {
  'SavedReportCard.ButtonsWrapper.ViewAll': ({ }, outlet) => {
    outlet({ action: 'viewAll' });
  },
  'SavedReportCard.ButtonsWrapper.CreateNew': ({ }, outlet) => {
    outlet({ action: 'createNew' });
  },
};
